import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApiFluidLossVerticalHeaderComponent } from './api-fluid-loss/api-fluid-loss-vertical-header/api-fluid-loss-vertical-header.component';
import { ApiFluidLossVerticalComponent } from './api-fluid-loss/api-fluid-loss-vertical/api-fluid-loss-vertical.component';
import { ApisalintyVerticalHeaderComponent } from './apisalinity/apisalinty-vertical-header/apisalinty-vertical-header.component';
import { ApisalintyVerticalComponent } from './apisalinity/apisalinty-vertical/apisalinty-vertical.component';
import { DensityVerticalHeaderComponent } from './density/density-vertical-header/density-vertical-header.component';
import { DensityVerticalComponent } from './density/density-vertical/density-vertical.component';
import { ElectricalstabilityVerticalHeaderComponent } from './electricalstability/electricalstability-vertical-header/electricalstability-vertical-header.component';
import { ElectricalstabilityVerticalComponent } from './electricalstability/electricalstability-vertical/electricalstability-vertical.component';
import { HphtrheologyVerticalHeaderComponent } from './hphtrheology/hphtrheology-vertical-header/hphtrheology-vertical-header.component';
import { HphtrheologyVerticalComponent } from './hphtrheology/hphtrheology-vertical/hphtrheology-vertical.component';
import { HthpfluidlossVerticalHeaderComponent } from './hthpfluidloss/hthpfluidloss-vertical-header/hthpfluidloss-vertical-header.component';
import { HthpfluidlossVerticalComponent } from './hthpfluidloss/hthpfluidloss-vertical/hthpfluidloss-vertical.component';
import { OthersVerticalHeaderComponent } from './others/others-vertical-header/others-vertical-header.component';
import { OthersVerticalComponent } from './others/others-vertical/others-vertical.component';
import { PptVerticalHeaderComponent } from './ppt/ppt-vertical-header/ppt-vertical-header.component';
import { PptVerticalComponent } from './ppt/ppt-vertical/ppt-vertical.component';
import { PsdVerticalHeaderComponent } from './psd/psd-vertical-header/psd-vertical-header.component';
import { PsdVerticalComponent } from './psd/psd-vertical/psd-vertical.component';
import { PycnometerVerticalHeaderComponent } from './pycnometer/pycnometer-vertical-header/pycnometer-vertical-header.component';
import { PycnometerVerticalComponent } from './pycnometer/pycnometer-vertical/pycnometer-vertical.component';
import { RetortVerticalHeaderComponent } from './retort/retort-vertical-header/retort-vertical-header.component';
import { RetortVerticalComponent } from './retort/retort-vertical/retort-vertical.component';
import { RheologyVerticalHeaderComponent } from './rheology/rheology-vertical-header/rheology-vertical-header.component';
import { RheologyVerticalComponent } from './rheology/rheology-vertical/rheology-vertical.component';
import { SalinityVerticalHeaderComponent } from './salinity/salinity-vertical-header/salinity-vertical-header.component';
import { SalinityVerticalComponent } from './salinity/salinity-vertical/salinity-vertical.component';
import { StaticAgingVerticalHeaderComponent } from './static-aging/static-aging-vertical-header/static-aging-vertical-header.component';
import { StaticAgingVerticalComponent } from './static-aging/static-aging-vertical/static-aging-vertical.component';
import { WbmchloridesVerticalHeaderComponent } from './wbmchlorides/wbmchlorides-vertical-header/wbmchlorides-vertical-header.component';
import { WbmchloridesVerticalComponent } from './wbmchlorides/wbmchlorides-vertical/wbmchlorides-vertical.component';
import { WbmSalinityVerticalHeaderComponent } from './wbmsalinity/wbmsalinity-vertical-header/wbmsalinity-vertical-header.component';
import { WbmSalinityVerticalComponent } from './wbmsalinity/wbmsalinity-vertical/wbmsalinity-vertical.component';

const COMPONENTS = [
  ApiFluidLossVerticalHeaderComponent,
  ApiFluidLossVerticalComponent,
  ApisalintyVerticalHeaderComponent,
  ApisalintyVerticalComponent,
  DensityVerticalHeaderComponent,
  DensityVerticalComponent,
  ElectricalstabilityVerticalHeaderComponent,
  ElectricalstabilityVerticalComponent,
  HphtrheologyVerticalHeaderComponent,
  HphtrheologyVerticalComponent,
  HthpfluidlossVerticalHeaderComponent,
  HthpfluidlossVerticalComponent,
  OthersVerticalHeaderComponent,
  OthersVerticalComponent,
  PptVerticalHeaderComponent,
  PptVerticalComponent,
  PsdVerticalHeaderComponent,
  PsdVerticalComponent,
  PycnometerVerticalHeaderComponent,
  PycnometerVerticalComponent,
  RetortVerticalHeaderComponent,
  RetortVerticalComponent,
  RheologyVerticalHeaderComponent,
  RheologyVerticalComponent,
  SalinityVerticalHeaderComponent,
  SalinityVerticalComponent,
  StaticAgingVerticalHeaderComponent,
  StaticAgingVerticalComponent,
  WbmchloridesVerticalHeaderComponent,
  WbmchloridesVerticalComponent,
  WbmSalinityVerticalHeaderComponent,
  WbmSalinityVerticalComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule],
  exports: COMPONENTS
})
export class VerticalTestComponentsModule {}